import * as React from "react";
const SvgFiRrConvertDocument = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m22.535 6.122-3.656-3.657a4.97 4.97 0 0 0-3.536-1.464H11c-2.206 0-4 1.794-4 4v5a1 1 0 1 0 2 0v-5c0-1.103.897-2 2-2h4v4c0 1.654 1.346 3 3 3h4v9c0 1.103-.897 2-2 2h-9c-1.103 0-2-.897-2-2v-1a1 1 0 1 0-2 0v1c0 2.206 1.794 4 4 4h9c2.206 0 4-1.794 4-4V9.658a4.97 4.97 0 0 0-1.465-3.536M17 7V3.498q.248.164.465.38l3.656 3.657q.213.214.377.464H18A1 1 0 0 1 17 7M6 22a1 1 0 0 1-1 1H4c-2.206 0-4-1.794-4-4V5c0-2.206 1.794-4 4-4h1a1 1 0 1 1 0 2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h1a1 1 0 0 1 1 1m-1-9h8.095l-1.802-1.793a1 1 0 1 1 1.414-1.415l2.799 2.801c.387.387.581.896.581 1.405V14c0 .509-.193 1.017-.58 1.404l-2.8 2.802a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l1.792-1.793H5a1 1 0 1 1 0-2z"
    />
  </svg>
);
export default SvgFiRrConvertDocument;
